import { useLang } from '@/i18n';
import { useProductStore } from '@elem/compPage/river-3-ups-portable-power-station/ProductProvider';
import styles from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import EfLink from '@elem/ui/ef-link';

export default function TheComp() {
    const { pageStatus } = useProductStore();
    const IS_LAUNCH = pageStatus !== 'statusA';
    // console.log('pagesss', pageStatus);

    const { t } = useLang('theProduct');
    const config = {
        contactListId: ['573056449'],
        isMulti: true,
        fields: [
            {
                id: '11571',
                type: 'multiple',
                value: [5],
                overwrite: false,
            },
        ],
        tipsObj: {
            btnText: t('A_subscribe'),
            placeholder: t('A_placeholder'),
            // tipsEmpty: t('A_tip_empty'),
            // tipsTypeError: t('A_tip_error'),
            // successTips: t('A_tip_success'),
            // tipsCheck: t('A_tip_check'),
        },
        needTerms: true,
        termsHtml:
            "*I agree to <a href='https://account.ecoflow.com/agreement/en-au/PrivacyPolicy.html' target='_blank'>EcoFlow's Privacy Policy</a> and <a href='https://account.ecoflow.com/agreement/en-au/TermsOfUse.html' target='_blank'>Terms of Service</a>.",
    };

    return (
        <div className={styles.comp}>
            <EfImg
                className="banner-img"
                pc="https://websiteoss.ecoflow.com/upload/image/1736418018802/1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1736418018642/1_M.jpg"
            />
            <div className="banner-info">
                <p className="banner-label">{IS_LAUNCH ? t('A_label_2') : t('A_label_1')}</p>
                <p className="banner-title">{IS_LAUNCH ? t('A_title_2') : t('A_title_1')}</p>
                <p className="banner-desc">{t('A_desc')}</p>
                {IS_LAUNCH ? (
                    <>
                        <EfLink
                            className="banner-btn"
                            href="https://au.ecoflow.com/products/river-3-ups"
                            target="_blank"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: 'EcoFlow River 3 UPS',
                                position: 'Product Launch',
                            }}
                        >
                            {t('A_btn')}
                        </EfLink>
                    </>
                ) : (
                    <EfEmarsysEmail {...config} />
                )}
            </div>
        </div>
    );
}
